import { type } from '@ngrx/signals';
import { eventGroup } from '@ngrx/signals/events';
import { createFormStoreEvents } from '../create-form-store-events';

export const cargoDetailsFormEvents = createFormStoreEvents('cargoDetailsStore');

export const cargoDetailsEvents = eventGroup({
  source: 'cargoDetailsStore',
  events: {
    addHoseOn: type<void>(),
    addHoseOff: type<void>(),
    addHeating: type<void>(),
    removeHoseOn: type<number>(),
    removeHoseOff: type<number>(),
    removeHeating: type<number>(),
  },
});
